import {
  APPOINTMENT_STATUS,
  BOOKING_TYPE,
  CUSTOMER_TYPE_NAME,
} from '../models';

export class ColorUtils {
  public static convertHexToRgbA(hex: string, opacity = 1): string {
    let c;

    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');

      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }

      c = '0x' + c.join('');
      // tslint:disable-next-line:no-bitwise
      return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(
        ','
      )},${opacity})`;
    }

    return hex;
  }

  public static getCustomerColorToDisplay(
    name: string | CUSTOMER_TYPE_NAME
  ): string {
    switch (name) {
      case CUSTOMER_TYPE_NAME.VIP:
        return '#4363d8';
      case CUSTOMER_TYPE_NAME.NEW:
        return '#ffe119';
      case CUSTOMER_TYPE_NAME.REGULAR:
        return '#3cb44b';
      case CUSTOMER_TYPE_NAME.AT_RISK:
        return '#e6194b';
      case CUSTOMER_TYPE_NAME.NORMAL:
        return '#f58231';
      default:
        return '#f58231';
    }
  }

  public static getCustomerAvatarTextColorToDisplay(
    name: string | CUSTOMER_TYPE_NAME
  ): string {
    switch (name) {
      case CUSTOMER_TYPE_NAME.VIP:
        return '#ffffff';
      case CUSTOMER_TYPE_NAME.NEW:
        return '#000000';
      case CUSTOMER_TYPE_NAME.REGULAR:
        return '#ffffff';
      case CUSTOMER_TYPE_NAME.AT_RISK:
        return '#ffffff';
      case CUSTOMER_TYPE_NAME.NORMAL:
        return '#ffffff';
      default:
        return '#000000';
    }
  }

  public static getAppointmentTypeColor(type: BOOKING_TYPE): string {
    switch (type) {
      case BOOKING_TYPE.BLOCKER:
        return '#ABB2B9';
      case BOOKING_TYPE.AGENT:
        return '#A800C7';
      case BOOKING_TYPE.TREATWELL:
        return '#F75833';
      case BOOKING_TYPE.RWG:
        return '#4081EC';
      case BOOKING_TYPE.TELEPHONE:
        return '#ECFF07';
      case BOOKING_TYPE.ONLINE:
        return '#2ECC71';
      default:
        return '#000000';
    }
  }

  public static getAppointmentStatusColor(status: APPOINTMENT_STATUS): string {
    switch (status) {
      case APPOINTMENT_STATUS.BLOCKER:
        return '#ABB2B9';
      case APPOINTMENT_STATUS.EXPIRED:
        return '#FFAE00';
      case APPOINTMENT_STATUS.CUSTOMER_CANCELLED:
        return '#FF0074';
      case APPOINTMENT_STATUS.BO_CANCELLED:
        return '#FF0000';
      case APPOINTMENT_STATUS.FULFILLED:
        return '#2ECC71';
      case APPOINTMENT_STATUS.CHECKED_IN:
        return '#000FFF';
      case APPOINTMENT_STATUS.CONFIRMED:
        return '#ECFF07';
      default:
        return '#ABB2B9';
    }
  }

  public static getListOfCssColor(numberOfColor?: number): string[] {
    const colorList: string[] = [
      'blue',
      'green',
      'yellow',
      'red',
      'purple',
      'lime',
      'fuchsia',
      'orange',
      'aqua',
      'navy',
      'maroon',
      'aquamarine',
      'blueviolet',
      'chocolate',
      'darkblue',
      'darkgrey',
      'darkkhaki',
      'darkmagenta',
      'darksalmon',
      'darkseagreen',
      'darkslateblue',
      'darkslategray',
      'deeppink',
      'firebrick',
      'gold',
      'hotpink',
      'indigo',
      'lightpink',
      'darkorange',
      'silver',
      'aliceblue',
      'antiquewhite',
      'brown',
      'burlywood',
      'cadetblue',
      'chartreuse',
      'coral',
      'cornflowerblue',
      'cornsilk',
      'crimson',
      'cyan',
      'darkgoldenrod',
      'darkgreen',
      'darkorchid',
      'darkred',
      'darkturquoise',
      'darkviolet',
      'dimgrey',
      'dodgerblue',
      'goldenrod',
      'greenyellow',
      'indianred',
      'khaki',
      'lavender',
    ];
    return numberOfColor ? colorList.slice(0, numberOfColor) : colorList;
  }
}
